import { render, staticRenderFns } from "./fila-cirurgia.vue?vue&type=template&id=06e7db1e&scoped=true&"
import script from "./fila-cirurgia.vue?vue&type=script&lang=js&"
export * from "./fila-cirurgia.vue?vue&type=script&lang=js&"
import style0 from "./fila-cirurgia.vue?vue&type=style&index=0&id=06e7db1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e7db1e",
  null
  
)

export default component.exports